// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.trending-products {

    /* background-color: #E1F5FE;
    
    background-image: url('../Assets/Home-Page/background .png'); */
    position:relative;
    
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity:1;
    width:100vw;
    height:120%;
    display: flex;
    align-items: center;
    padding: 20px 0px;
    z-index: 0;
    
    
    

}

.trending-products ::before{
    content: '';
        
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        
        background-color: rgba(255, 235, 238, 0.3);
       
        background-size: cover;
        
        background-position: center;
    
        opacity: 0.3;
        
        z-index: -1;
        
                
}



.trending-products-title .title {
    font-family: 'Raleway','sans-serif';
    font-weight: 700;
    font-size:36px;
    margin-top: 0px;
   
}


.trending-products-buttons{
    margin-top: -10px;
}

.trending-products-buttons button{
       color: #fff;
        font-size: 15px;
        width: 131.52px;
        height: 42px;
        margin-right: 10px;
        border-radius: 25px;
        text-decoration: underline;
        font-family: 'Inter','sans-serif';
        position: relative;
        overflow: hidden;
        cursor: pointer;
        z-index: 1;
        background-color:#fff;
        

}




.trending-products-buttons button::after {
    /* this is what all  will be done when mouse outs from the button */
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #F2C713;
    z-index: -1;
    border-radius: 10rem;
    transition: 0.3s ease all;
    transform: scale(0, 1);

    /* this is you are to change for diffirent transition; */

    transform-origin: bottom left;
    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}



.trending-products-buttons button:hover::after {
    transform: scale(1, 1);
    transform-origin: top left;
}

.trending-products-cards {
    position: relative;
    overflow: hidden;
    width: 100%;
    display: flex;

    justify-content: center;
    align-items: center;
   

}


.trending-products-card ul {
    list-style-type: none;
    display: flex;
    
    margin-top: 0px;
    padding: 0;
    flex-direction: row;

    align-items: center;
    transition: transform 0.2s ease;

    width: max-content;



}

.product-card {
    background-color: #fff;
    width: 300px;
    height: 530px;
    margin: 30px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    flex-shrink: 0;
    opacity: 1;
    position: relative;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;

}

.discounted-badge {
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: #ed2727;
    /* Optional: background color */
    padding: 3px;
    border-radius: 3px;
    font-weight: bold;
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    letter-spacing: 1px;
    font-weight: 400;
    /* Optional: text color */
}

.product-card img {
    width: 70%;
    height: 50%;
    margin-top: 30px;
}

.product-card img:hover{
    transform: scale(1.1)
}
.product-card p {
    font-family: 'Poppins', sans-serif;
    /* width: 70%; */
    font-weight: 500;
    
    

}

.price-details {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    justify-items:center;
    margin-bottom: 5px;
    margin-top: auto;
    
    

}

.price-details p {
    margin: 0px 30px;
    text-align: left;
    width:100%;
    font-size:15px;
    color:#444;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.add-cart {
    display: flex;
    flex-direction: row;
    margin:20px;


}

.add-cart p {
    font-size: small;
    width: 100%;
    margin-top: -20px;
}
.background-image {
    background-color: #F0FDFF;
    width: 100vw;
    height: 100vh;
    margin-left: -40px;

}



@media screen and (max-width:768px){
    .trending-products-buttons {
            margin-top: -10px;
            display: flex;
            flex-direction: column;
        }
        .trending-products-buttons button {
            color: #fff;
            font-size: 15px;
            width: 60vw;
            height: 42px;
            margin-right: 10px;
            border-radius: 25px;
            text-decoration: underline;
            font-family: 'Inter', 'sans-serif';
            position: relative;
            overflow: hidden;
            cursor: pointer;
    
            z-index: 1
        }

                .trending-products-card ul {
                    list-style-type: none;
                    display: flex;
        
                    margin-top: 0px;
                    padding: 0;
                    flex-direction: column;
        
                    align-items: center;
                    transition: transform 0.2s ease;
        
                    width: max-content;
        
        
        
                }
}`, "",{"version":3,"sources":["webpack://./src/Styles/TrendingProducts.css"],"names":[],"mappings":";;AAEA;;IAEI;;mEAE+D;IAC/D,iBAAiB;;IAEjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;;;;;AAKd;;AAEA;IACI,WAAW;;QAEP,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;;QAEZ,0CAA0C;;QAE1C,sBAAsB;;QAEtB,2BAA2B;;QAE3B,YAAY;;QAEZ,WAAW;;;AAGnB;;;;AAIA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,eAAe;;AAEnB;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;OACO,WAAW;QACV,eAAe;QACf,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,0BAA0B;QAC1B,iCAAiC;QACjC,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,UAAU;QACV,qBAAqB;;;AAG7B;;;;;AAKA;IACI,mEAAmE;IACnE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;;IAEtB,wDAAwD;;IAExD,6BAA6B;IAC7B,0DAA0D;IAC1D,0DAA0D;AAC9D;;;;AAIA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;;IAEb,uBAAuB;IACvB,mBAAmB;;;AAGvB;;;AAGA;IACI,qBAAqB;IACrB,aAAa;;IAEb,eAAe;IACf,UAAU;IACV,mBAAmB;;IAEnB,mBAAmB;IACnB,+BAA+B;;IAE/B,kBAAkB;;;;AAItB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;;AAEnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;AACJ;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;;;;AAIpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;;;;AAIpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;;;AAGf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;;AAEtB;;;;AAIA;IACI;YACQ,iBAAiB;YACjB,aAAa;YACb,sBAAsB;QAC1B;QACA;YACI,WAAW;YACX,eAAe;YACf,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,mBAAmB;YACnB,0BAA0B;YAC1B,kCAAkC;YAClC,kBAAkB;YAClB,gBAAgB;YAChB,eAAe;;YAEf;QACJ;;gBAEQ;oBACI,qBAAqB;oBACrB,aAAa;;oBAEb,eAAe;oBACf,UAAU;oBACV,sBAAsB;;oBAEtB,mBAAmB;oBACnB,+BAA+B;;oBAE/B,kBAAkB;;;;gBAItB;AAChB","sourcesContent":["\n\n.trending-products {\n\n    /* background-color: #E1F5FE;\n    \n    background-image: url('../Assets/Home-Page/background .png'); */\n    position:relative;\n    \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    opacity:1;\n    width:100vw;\n    height:120%;\n    display: flex;\n    align-items: center;\n    padding: 20px 0px;\n    z-index: 0;\n    \n    \n    \n\n}\n\n.trending-products ::before{\n    content: '';\n        \n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        \n        background-color: rgba(255, 235, 238, 0.3);\n       \n        background-size: cover;\n        \n        background-position: center;\n    \n        opacity: 0.3;\n        \n        z-index: -1;\n        \n                \n}\n\n\n\n.trending-products-title .title {\n    font-family: 'Raleway','sans-serif';\n    font-weight: 700;\n    font-size:36px;\n    margin-top: 0px;\n   \n}\n\n\n.trending-products-buttons{\n    margin-top: -10px;\n}\n\n.trending-products-buttons button{\n       color: #fff;\n        font-size: 15px;\n        width: 131.52px;\n        height: 42px;\n        margin-right: 10px;\n        border-radius: 25px;\n        text-decoration: underline;\n        font-family: 'Inter','sans-serif';\n        position: relative;\n        overflow: hidden;\n        cursor: pointer;\n        z-index: 1;\n        background-color:#fff;\n        \n\n}\n\n\n\n\n.trending-products-buttons button::after {\n    /* this is what all  will be done when mouse outs from the button */\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #F2C713;\n    z-index: -1;\n    border-radius: 10rem;\n    transition: 0.3s ease all;\n    transform: scale(0, 1);\n\n    /* this is you are to change for diffirent transition; */\n\n    transform-origin: bottom left;\n    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n\n\n.trending-products-buttons button:hover::after {\n    transform: scale(1, 1);\n    transform-origin: top left;\n}\n\n.trending-products-cards {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    display: flex;\n\n    justify-content: center;\n    align-items: center;\n   \n\n}\n\n\n.trending-products-card ul {\n    list-style-type: none;\n    display: flex;\n    \n    margin-top: 0px;\n    padding: 0;\n    flex-direction: row;\n\n    align-items: center;\n    transition: transform 0.2s ease;\n\n    width: max-content;\n\n\n\n}\n\n.product-card {\n    background-color: #fff;\n    width: 300px;\n    height: 530px;\n    margin: 30px 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n    flex-shrink: 0;\n    opacity: 1;\n    position: relative;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n\n}\n\n.discounted-badge {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    background-color: #ed2727;\n    /* Optional: background color */\n    padding: 3px;\n    border-radius: 3px;\n    font-weight: bold;\n    color: #fff;\n    font-family: 'Poppins', sans-serif;\n    font-size: 12px;\n    letter-spacing: 1px;\n    font-weight: 400;\n    /* Optional: text color */\n}\n\n.product-card img {\n    width: 70%;\n    height: 50%;\n    margin-top: 30px;\n}\n\n.product-card img:hover{\n    transform: scale(1.1)\n}\n.product-card p {\n    font-family: 'Poppins', sans-serif;\n    /* width: 70%; */\n    font-weight: 500;\n    \n    \n\n}\n\n.price-details {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    justify-items:center;\n    margin-bottom: 5px;\n    margin-top: auto;\n    \n    \n\n}\n\n.price-details p {\n    margin: 0px 30px;\n    text-align: left;\n    width:100%;\n    font-size:15px;\n    color:#444;\n    font-weight: 500;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.add-cart {\n    display: flex;\n    flex-direction: row;\n    margin:20px;\n\n\n}\n\n.add-cart p {\n    font-size: small;\n    width: 100%;\n    margin-top: -20px;\n}\n.background-image {\n    background-color: #F0FDFF;\n    width: 100vw;\n    height: 100vh;\n    margin-left: -40px;\n\n}\n\n\n\n@media screen and (max-width:768px){\n    .trending-products-buttons {\n            margin-top: -10px;\n            display: flex;\n            flex-direction: column;\n        }\n        .trending-products-buttons button {\n            color: #fff;\n            font-size: 15px;\n            width: 60vw;\n            height: 42px;\n            margin-right: 10px;\n            border-radius: 25px;\n            text-decoration: underline;\n            font-family: 'Inter', 'sans-serif';\n            position: relative;\n            overflow: hidden;\n            cursor: pointer;\n    \n            z-index: 1\n        }\n\n                .trending-products-card ul {\n                    list-style-type: none;\n                    display: flex;\n        \n                    margin-top: 0px;\n                    padding: 0;\n                    flex-direction: column;\n        \n                    align-items: center;\n                    transition: transform 0.2s ease;\n        \n                    width: max-content;\n        \n        \n        \n                }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
